export const movieGenres = [
  { key: "action", label: "动作", icon: "ri-sword-line" },
  { key: "sci-fi", label: "科幻", icon: "ri-planet-line" },
  { key: "romance", label: "爱情", icon: "ri-heart-3-line" },
  { key: "comedy", label: "喜剧", icon: "ri-emotion-happy-line" },
  { key: "mystery", label: "悬疑", icon: "ri-question-mark" },
  { key: "drama", label: "剧情", icon: "ri-movie-2-line" },
  { key: "animation", label: "动画", icon: "ri-magic-line" },
  { key: "adventure", label: "冒险", icon: "ri-compass-3-line" },
];

export const tvGenres = [
  { key: "urban", label: "都市", icon: "ri-building-2-line" },
  { key: "costume", label: "古装", icon: "ri-ancient-gate-line" },
  { key: "mystery", label: "悬疑", icon: "ri-question-mark" },
  { key: "romance", label: "爱情", icon: "ri-heart-3-line" },
  { key: "family", label: "家庭", icon: "ri-home-heart-line" },
  { key: "history", label: "历史", icon: "ri-book-2-line" },
  { key: "comedy", label: "喜剧", icon: "ri-emotion-happy-line" },
  { key: "sci-fi", label: "科幻", icon: "ri-planet-line" },
];

export const quickEntries = [
  { label: "电影", to: "/category/movie", icon: "ri-film-line" },
  { label: "电视剧", to: "/category/tv", icon: "ri-tv-2-line" },
  { label: "动作", to: "/category/movie?genre=action", icon: "ri-sword-line" },
  { label: "爱情", to: "/category/movie?genre=romance", icon: "ri-heart-3-line" },
  { label: "科幻", to: "/category/movie?genre=sci-fi", icon: "ri-planet-line" },
  { label: "悬疑", to: "/category/movie?genre=mystery", icon: "ri-question-mark" },
  { label: "喜剧", to: "/category/tv?genre=comedy", icon: "ri-emotion-happy-line" },
  { label: "动画", to: "/category/movie?genre=animation", icon: "ri-magic-line" },
];